import { Component, OnInit, Input, Output, EventEmitter,ElementRef,QueryList, ViewChildren  } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { OrderService } from 'src/app/services/order/order.service';
import { CustomerdosService } from 'src/app/services/customerdos/customerdos.service';
import { TaskService } from 'src/app/services/task/task.service';
import { PhleboService } from 'src/app/services/phlebo/phlebo.service';
import { FormControl, FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-TableModal',
    templateUrl: './TableModal.component.html',
    styleUrls: ['./TableModal.component.scss']
})
export class TableModalComponent implements OnInit {
    @Input() props: any;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
    @ViewChildren('checkboxes') checkboxes: QueryList<ElementRef>;
    public fileName: any;
    public file: any;
    public fileerrmsg: boolean;

    public title: string;
    public subTitle: string;
    public type: string;
    public data: any;
    public visit_id: any;
    public page: any = 1;
    public isLoadedTable = true;
    visit_number: any;
    exportFileList: any;
    notimportedorderList: any;
    bankDepositList: any;
    public checkdata: any = [];
    total_amount_collected: any;
    public bankdeposit: FormGroup;
    public isBtnLoaded = false;
    citylistForDropdown: any;
    today=new Date();
    viewTaskDetail: any;
    task_location_photo: any=[];
    public barcodedata: any;
    checkExisit=true;
    isDeviceService:boolean = false;
    public is_location_photo = false;
    constructor(
        private ngbModal: NgbActiveModal,
        private toastr: ToastrService,
        private OrderService: OrderService,
        private invoiceService : InvoiceService,
        private DosService:CustomerdosService,
        private formBuilder: FormBuilder,
        private taskService:TaskService,
        public phleboService:PhleboService,
        private actRoute: ActivatedRoute

    ) {
        this.actRoute.paramMap.subscribe(params => {
            this.visit_id = params.get('id');
            this.checkExisit =false;
        });
    }

    ngOnInit(): void {
        this.isDeviceService = localStorage.getItem('is_device_service') == 'true' || localStorage.getItem('is_device_service') == '1';
        this.bankdeposit = this.formBuilder.group({
            diposit_date: ['', Validators.required],
            amount: ['', [Validators.required]],
            city_id : ['', [Validators.required]],
            upload: ['No', Validators.required,],
        });


this.DosService.getallcity().subscribe((data) => {
    this.citylistForDropdown = data.data;
  });



        this.setDialogProps(this.props);

        switch (this.type) {

            case 'viewLocationDetail':
              this.taskService.getPendingLocation(this.data.id,this.data.status).subscribe(
                (res: any) => {
                  this.viewTaskDetail = res.data;
                },
                (err: any) => {
                    this.onClose();
                    this.toastr.error(`${err.statusText}`);

                },
                ()=>{
                    this.isLoadedTable = false;
                }
            );
                break;

                case 'viewLocationPhoto':

                    this.taskService.get_location_photo(this.data.task_id,this.data.id).subscribe((data) => {
                        this.task_location_photo = data.data;


                        data.data.forEach(element => {
                            if(element.collection_photo)
                            {
                            this.is_location_photo = true;
                            }
                            if(element.delivery_photo)
                            {
                            this.is_location_photo = true;
                            }

                        });





                    });

                break;
            case 'viewBankToDeposit':
                this.OrderService.getBankDepositDataList(this.data).subscribe(
                    (res: any) => {
                        this.bankDepositList = res.data.data;
                        this.total_amount_collected = res.data.amount;
                        this.bankdeposit.get('amount').setValue( res.data.amount);

                        let i=0;
                        const checkdatanew = [];
                        res.data.data.forEach(function (element) {
                            checkdatanew.push(element.id);

                            i++;
                          });
                          this.checkdata =checkdatanew;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    },
                    ()=>{
                        this.isLoadedTable = false;
                    }
                );
                break;
            case 'downloadexportedDosfile':
                this.DosService.getexportFileList().subscribe(
                    (res: any) => {
                        this.exportFileList = res.data;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    },
                    ()=>{
                        this.isLoadedTable = false;
                    }
                );
                break;
                 case 'notUploadedDos':
                this.DosService.getNotImportedOrderList().subscribe(
                    (res: any) => {
                        this.notimportedorderList = res.data;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    },
                    ()=>{
                        this.isLoadedTable = false;
                    }
                );
                break;
            case 'downloadexportedfile_distance':
                this.OrderService.getexportFileListNew('export-distance-report').subscribe(
                    (res: any) => {
                        this.exportFileList = res.data;
                        this.isLoadedTable = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    },
                    ()=>{
                        this.isLoadedTable = false;
                    }
                );
                break;
            case 'downloadexportedfile':
                this.OrderService.getexportFileList().subscribe(
                    (res: any) => {
                        this.exportFileList = res.data;
                        this.isLoadedTable = false;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    },
                    ()=>{
                        this.isLoadedTable = false;
                    }
                );
                break;
                case 'downloadexportedfile_paymentreconcilation':
                this.OrderService.getexportFileListReconcilation().subscribe(
                    (res: any) => {
                        this.exportFileList = res.data;

                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    },
                    ()=>{
                        this.isLoadedTable = false;
                    }
                );
                break;
                case 'notUploadedOrder':
                this.OrderService.getNotImportedOrderList().subscribe(
                    (res: any) => {
                        this.notimportedorderList = res.data;
                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    },
                    ()=>{
                        this.isLoadedTable = false;
                    }
                );
                break;



                case 'viewTemperature':

                this.OrderService.viewTemperature(this.data.id).subscribe(
                    (res: any) => {
                        this.data = res.data;

                    },
                    (err: any) => {
                        this.onClose();
                        this.toastr.error(`${err.statusText}`);

                    },
                    ()=>{
                        this.isLoadedTable = false;
                    }
                );
                break;

                case 'rejectedID':


        }
    }

    setDialogProps(dialogdata: any) {
        this.title = dialogdata.title;
        this.subTitle = dialogdata.subTitle;
        this.type = dialogdata.type;
        this.data = dialogdata.data;
        this.page = dialogdata.page;
        this.visit_number = dialogdata.visit_number;
        //
    }


    onClose() {
        this.passEntry.next(this.page);
        this.ngbModal.close();
    }
    get bankdepositInfo() {
        return this.bankdeposit.controls;
    }

    onCheckChange(event) {
        const checkItem = this.checkdata;
        if (event.target.checked) {
            checkItem.push(event.target.value);
        } else {
          let i = 0;
          checkItem.forEach(function (element) {
            if (element == event.target.value) {
              checkItem.splice(i, 1);

              return;
            }
            i++;
          });
        }

        this.checkdata = checkItem;


        this.OrderService.getTotalAmountBankDeposit(this.checkdata).subscribe((data) => {
            this.bankdeposit.get('amount').setValue( data.data);



        });
      }
      onCloseNext() {


         this.passEntry.next(this.page);
         this.ngbModal.close();
     }
     onFileSelect(event) {
        if (event.target.files.length > 0) {
            const image = event.target.files[0];
            this.fileName = image.name;
            this.file = image;
            this.fileerrmsg = false;
        }
    }

    create() {

        if (this.bankdeposit.valid) {
            this.isBtnLoaded = true;
            this.OrderService.addBankDeposit(this.bankdeposit.value, this.file,this.checkdata).subscribe((res: any) => {
                if (res.success) {
                    this.toastr.success(`${res.message}`);
                } else {
                    if (res.message) {
                        this.toastr.error(`${res.message}`);
                    } else {
                        this.toastr.error(`Added Successfully`);
                    }
                }
            },
            (err: any) => {
                this.toastr.error(`${err}`);
            },
            () => {
                this.passEntry.next(this.page);
                this.ngbModal.close();
                this.isBtnLoaded = false;
            })
        }

        else {
            this.bankdeposit.markAllAsTouched();
        }


}
}
